/* ============================================================
   NOOK Config Explorer (sections/nook-config-explorer.liquid).
   Loaded deferred, only by this section; safe to include twice.

   Looks: hidden [data-cx-look] elements rendered by Liquid, one per
   photographed combination (porch, roof, terrace, finish) with its
   srcset, alt and caption. Only the initial image is in the markup;
   the others are built on demand and prefetched on chip hover/focus.

   Selecting a value: the look matching ALL selections wins; if none,
   the look with the new value that keeps the most other selections,
   preferring to keep the finish, then the terrace, then porch/roof.
   Every chip then shows that look's values, so the stage is never
   blank for a combination that was never photographed.

   Selection is transactional: a tap only REQUESTS a look. Chips,
   caption and the CTA href stay on the committed look until the new
   image has loaded; only then is it committed (and tracked). A failed
   image leaves everything on the previous look, and the next tap
   retries. Rapid taps: each tap resolves against the latest requested
   look, the last one wins, and stale loads are dropped.

   Swap = crossfade: the new image fades in over the old one (opacity
   only), the old one is removed after the fade; instant under
   reduced motion.

   Tracking (NookTrack, dataLayer fallback): nook_config_explorer_view
   (>= 50 % in view for 1 s, once; the dwell restarts when the tab
   becomes visible again), nook_config_explorer_select
   { group, value, look, snapped }, nook_config_explorer_cta { look }.

   Every listener, observer and timer an instance creates is registered
   with it, so `shopify:section:unload` disposes it completely and
   `shopify:section:load` re-inits without duplicates.
   ============================================================ */
(function () {
  'use strict';

  if (window.NookConfigExplorer) {
    window.NookConfigExplorer.scan(document);
    return;
  }

  // Configurator radio values for option_acabados_exteriores.
  var CFG_FINISH = { black: 'madera_negra', oak: 'madera_roble', golden: 'millboard_oak' };
  var GROUPS = ['porch', 'roof', 'terrace', 'finish'];
  var FADE_MS = 450;
  // Lexicographic preference among the selections a fallback keeps.
  var KEEP_WEIGHT = { finish: 8, terrace: 4, porch: 1, roof: 1 };
  var instances = [];

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function track(event, props) {
    if (window.NookTrack) {
      window.NookTrack.push(event, props);
      return;
    }
    if (typeof window.dataLayer === 'undefined') return;
    var payload = { event: event };
    Object.keys(props).forEach(function (k) { payload[k] = props[k]; });
    window.dataLayer.push(payload);
  }

  function readLooks(root) {
    var els = root.querySelectorAll('[data-cx-look]');
    return Array.prototype.map.call(els, function (el) {
      return {
        el: el,
        id: el.getAttribute('data-cx-look'),
        porch: el.getAttribute('data-porch') || 'none',
        roof: el.getAttribute('data-roof') || 'flat',
        terrace: el.getAttribute('data-terrace') || 'no',
        finish: el.getAttribute('data-finish') || 'oak',
        caption: el.getAttribute('data-caption') || '',
        alt: el.getAttribute('data-alt') || '',
        src: el.getAttribute('data-src') || '',
        srcset: el.getAttribute('data-srcset') || '',
        w: el.getAttribute('data-w') || '',
        h: el.getAttribute('data-h') || ''
      };
    });
  }

  // The analytics key of a look, e.g. "pitched-flat-yes-oak".
  function lookKey(look) {
    return GROUPS.map(function (g) { return look[g]; }).join('-');
  }

  /* The look for `current` with `group` set to `value`. Exact match first;
     otherwise the look with that value keeping the most other selections,
     ties broken by finish, then terrace, then porch/roof, then order. */
  function resolve(looks, current, group, value) {
    var best = null;
    var bestScore = -1;
    for (var i = 0; i < looks.length; i++) {
      var look = looks[i];
      if (look[group] !== value) continue;
      var kept = 0;
      var pref = 0;
      for (var j = 0; j < GROUPS.length; j++) {
        var g = GROUPS[j];
        if (g !== group && look[g] === current[g]) {
          kept += 1;
          pref += KEEP_WEIGHT[g];
        }
      }
      if (kept === GROUPS.length - 1) return look;
      var score = kept * 100 + pref;
      if (score > bestScore) {
        best = look;
        bestScore = score;
      }
    }
    return best;
  }

  /* ── One section ─────────────────────────────────────────── */
  function init(root) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root === root) return;
    }

    var looks = readLooks(root);
    var stage = root.querySelector('[data-cx-stage]');
    if (!looks.length || !stage) return;

    var caption = root.querySelector('[data-cx-caption]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-cx-value]'));
    var sizes = stage.getAttribute('data-sizes') || '100vw';
    var initialId = root.getAttribute('data-cx-initial');
    var current = looks[0];
    looks.forEach(function (l) { if (l.id === initialId) current = l; });
    var passCta = root.querySelector('[data-cx-cta][data-cx-pass-look]');
    var ctaBase = passCta ? (passCta.getAttribute('href') || '').split('#')[0] : '';

    /* Open the configurator on the look the visitor built. The configurator
       restores `#config=<base64 JSON>` (garden-room-configurator.liquid,
       restore block): feature toggles by key, the exterior finish as the
       radio value of option_acabados_exteriores. A sloped porch in the
       configurator is the porch plus the sloped roof. */
    function configHref(look) {
      var opts = { acabados_exteriores: CFG_FINISH[look.finish] || CFG_FINISH.oak };
      if (look.porch !== 'none') opts.porche = 'si';
      if (look.roof === 'pitched' || look.porch === 'pitched') opts.cubierta_inclinada = 'si';
      if (look.terrace === 'yes') opts.terraza = 'si';
      try {
        return ctaBase + '#config=' + window.btoa(JSON.stringify({ options: opts, addons: [] }));
      } catch (err) {
        return ctaBase;
      }
    }
    function updateCta(look) {
      if (passCta && ctaBase) passCta.setAttribute('href', configHref(look));
    }
    updateCta(current);

    var listeners = [];
    var observers = [];
    var timers = [];
    var prefetched = {};
    var seq = 0;
    // The look a tap asked for whose image is still loading, or null.
    var pending = null;

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      listeners.push([target, type, fn, opts]);
    }

    function later(fn, ms) {
      var id = setTimeout(function () {
        timers = timers.filter(function (t) { return t !== id; });
        fn();
      }, ms);
      timers.push(id);
    }

    function chipGroup(chip) {
      var wrap = chip.closest('[data-cx-group]');
      return wrap ? wrap.getAttribute('data-cx-group') : null;
    }

    function setImageSources(img, look) {
      img.decoding = 'async';
      img.sizes = sizes;
      if (look.srcset) img.srcset = look.srcset;
      img.src = look.src;
    }

    function prefetch(look) {
      if (!look || look === current || prefetched[look.id] || !look.src) return;
      var img = new Image();
      var id = look.id;
      // A failed prefetch is forgotten, so the next hover or tap refetches.
      img.onerror = function () {
        if (prefetched[id] === img) delete prefetched[id];
      };
      setImageSources(img, look);
      prefetched[id] = img;
    }

    function buildImage(look) {
      var img = document.createElement('img');
      img.className = 'nook-cx__img';
      img.alt = look.alt;
      if (look.w) img.width = parseInt(look.w, 10) || 0;
      if (look.h) img.height = parseInt(look.h, 10) || 0;
      setImageSources(img, look);
      return img;
    }

    // Calls ok() once the image is decoded (or loaded), bad() on error.
    function whenReady(img, ok, bad) {
      var settled = false;
      function done() {
        if (settled) return;
        settled = true;
        ok();
      }
      function failed() {
        if (settled) return;
        settled = true;
        bad();
      }
      img.addEventListener('error', failed, { once: true });
      if (typeof img.decode === 'function') {
        img.decode().then(done, function () {
          // decode() also rejects for an aborted request; the load or
          // error event then decides.
          if (img.complete && img.naturalWidth > 0) {
            done();
          } else if (img.complete) {
            failed();
          } else {
            img.addEventListener('load', done, { once: true });
          }
        });
      } else if (img.complete && img.naturalWidth > 0) {
        done();
      } else {
        img.addEventListener('load', done, { once: true });
      }
    }

    /* Crossfade: the loaded image sits on top at opacity 0 and fades in;
       everything under it is removed once the fade is done. */
    function crossfade(img) {
      var under = Array.prototype.filter.call(stage.querySelectorAll('.nook-cx__img'), function (el) {
        return el !== img;
      });
      under.forEach(function (el) {
        el.alt = '';
        el.setAttribute('aria-hidden', 'true');
      });
      // Commit opacity 0 before the class flips, so the fade runs.
      void img.offsetWidth;
      img.classList.add('is-current');
      var clear = function () {
        under.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
      };
      if (reducedMotion()) {
        clear();
      } else {
        later(clear, FADE_MS + 60);
      }
    }

    // Chips, caption and CTA href for the committed look.
    function render(look) {
      chips.forEach(function (chip) {
        var g = chipGroup(chip);
        var pressed = !!g && look[g] === chip.getAttribute('data-cx-value');
        chip.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      });
      if (caption && caption.textContent !== look.caption) caption.textContent = look.caption;
      updateCta(look);
    }

    function cancelPending() {
      if (!pending) return;
      if (pending.img.parentNode) pending.img.parentNode.removeChild(pending.img);
      pending = null;
      seq += 1;
      stage.removeAttribute('aria-busy');
    }

    function commit(look, img, meta) {
      current = look;
      stage.removeAttribute('aria-busy');
      render(look);
      crossfade(img);
      if (meta) {
        track('nook_config_explorer_select', { group: meta.group, value: meta.value, look: lookKey(look), snapped: meta.snapped });
      }
    }

    /* Ask for a look. Nothing visible changes until its image is ready;
       a newer request (or a return to the committed look) supersedes it. */
    function request(look, meta) {
      if (!look) return;
      if (look === current) {
        cancelPending();
        return;
      }
      if (pending && pending.look === look) return;
      cancelPending();
      seq += 1;
      var mine = seq;
      var img = buildImage(look);
      pending = { look: look, img: img, seq: mine };
      stage.setAttribute('aria-busy', 'true');
      stage.appendChild(img);
      whenReady(img, function () {
        if (!pending || pending.seq !== mine) return;
        pending = null;
        commit(look, img, meta);
      }, function () {
        if (img.parentNode) img.parentNode.removeChild(img);
        if (prefetched[look.id]) delete prefetched[look.id];
        if (pending && pending.seq === mine) {
          pending = null;
          stage.removeAttribute('aria-busy');
        }
      });
    }

    on(root, 'click', function (e) {
      var chip = e.target.closest('[data-cx-value]');
      if (chip && root.contains(chip)) {
        var group = chipGroup(chip);
        var value = chip.getAttribute('data-cx-value');
        // Resolve against the latest request, so rapid taps compound and
        // the last one wins.
        var base = pending ? pending.look : current;
        if (!group || base[group] === value) return;
        var target = resolve(looks, base, group, value);
        if (!target) return;
        var snapped = GROUPS.some(function (g) { return g !== group && target[g] !== base[g]; });
        request(target, { group: group, value: value, snapped: snapped });
        return;
      }
      var cta = e.target.closest('[data-cx-cta]');
      if (cta && root.contains(cta)) {
        track('nook_config_explorer_cta', { look: lookKey(current), url: cta.getAttribute('href') || '' });
      }
    });

    function warm(e) {
      var chip = e.target && e.target.closest ? e.target.closest('[data-cx-value]') : null;
      if (!chip) return;
      var group = chipGroup(chip);
      if (!group) return;
      prefetch(resolve(looks, pending ? pending.look : current, group, chip.getAttribute('data-cx-value')));
    }
    on(root, 'pointerover', warm);
    on(root, 'focusin', warm);

    // Theme editor: selecting a look block shows it.
    on(document, 'shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      for (var k = 0; k < looks.length; k++) {
        if (looks[k].el === e.target) {
          request(looks[k], null);
          return;
        }
      }
    });

    /* View: >= 50 % visible for a continuous 1 s, once. A section taller
       than the viewport counts once it covers >= 50 % of the viewport. */
    var viewTimer = null;
    function clearView() {
      if (viewTimer) {
        clearTimeout(viewTimer);
        viewTimer = null;
      }
    }
    if (typeof window.IntersectionObserver === 'function') {
      var steps = [0];
      for (var s = 1; s <= 20; s++) steps.push(s / 20);
      var viewDone = false;
      var io = null;
      var startView = function () {
        if (viewDone || viewTimer || document.hidden) return;
        viewTimer = setTimeout(function () {
          viewTimer = null;
          viewDone = true;
          if (io) io.disconnect();
          track('nook_config_explorer_view', { look: lookKey(current) });
        }, 1000);
      };
      var enoughInView = function (rect, visibleH, vh) {
        return visibleH > 0 && (visibleH >= rect.height * 0.5 || (rect.height > vh && visibleH >= vh * 0.5));
      };
      io = new IntersectionObserver(function (entries) {
        if (viewDone) return;
        var en = entries[entries.length - 1];
        var vh = (en.rootBounds && en.rootBounds.height) || window.innerHeight || 0;
        var enough = en.isIntersecting && enoughInView(en.boundingClientRect, en.intersectionRect.height, vh);
        if (enough) {
          startView();
        } else {
          clearView();
        }
      }, { threshold: steps });
      io.observe(root);
      observers.push(io);
      // The observer does not re-fire when a tab comes back: measure then.
      on(document, 'visibilitychange', function () {
        if (document.hidden) {
          clearView();
          return;
        }
        if (viewDone) return;
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var visibleH = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
        if (enoughInView(rect, visibleH, vh)) startView();
      });
    }

    function dispose() {
      cancelPending();
      seq += 1;
      clearView();
      timers.forEach(clearTimeout);
      timers = [];
      observers.forEach(function (o) { o.disconnect(); });
      observers = [];
      listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      listeners = [];
      prefetched = {};
      root.classList.remove('is-ready');
    }

    root.classList.add('is-ready');
    instances.push({ root: root, dispose: dispose });
  }

  function scan(scope) {
    var el = scope || document;
    var roots = Array.prototype.slice.call(el.querySelectorAll('[data-nook-cx]'));
    if (el.matches && el.matches('[data-nook-cx]')) roots.unshift(el);
    roots.forEach(init);
  }

  function disposeWithin(scope) {
    instances = instances.filter(function (inst) {
      if (scope === inst.root || scope.contains(inst.root) || !inst.root.isConnected) {
        inst.dispose();
        return false;
      }
      return true;
    });
  }

  window.NookConfigExplorer = { scan: scan, dispose: disposeWithin };
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { disposeWithin(e.target); });
})();
